<div class="wrapper">
    <div class="title">
        SynApps
    </div>
    <div class="message">
        Une erreur est survenue lors du chargement de l'application:
    </div>
    <div class="centered">
        <div class="message" [innerHTML]="ErrorMessages[code]"></div>
        <button mat-raised-button (click)="reload()">Recharger l'application</button>
    </div>
</div>
